function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === "function" &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? "symbol"
        : typeof obj;
    };
  }
  return _typeof(obj);
}

/*
 * Main JS script, will load in footer, often async
 */
ckdc.window = jQuery("window");
ckdc.html = jQuery("html");
ckdc.body = jQuery("body");
/*
 * Event handler for menu button on mobile devices
 */

var nav_btn = document.getElementById("nav-btn");

if (nav_btn) {
  nav_btn.addEventListener("click", function () {
    // Save scroll position
    if (!document.body.classList.contains("menu-active")) {
      localStorage.cachedScrollPos =
        window.pageYOffset !== undefined
          ? window.pageYOffset
          : (
              document.documentElement ||
              document.body.parentNode ||
              document.body
            ).scrollTop;
    }

    // Toggle the menu class on body
    document.body.classList.toggle("menu-active");
    document.body.classList.remove("search-active");

    // Restore scroll position
    if (!document.body.classList.contains("menu-active")) {
      window.scrollTo(0, localStorage.cachedScrollPos);
    }
  });
}
/*
 * Show and hide search field in header
 */

window.closeSearch = function (e, force) {
  var body = document.body;
  var shouldAlwaysClose = force || "Escape" == e.key;

  // Hinder interaction with the search form to close it.
  if (
    !shouldAlwaysClose &&
    !!~["FORM", "INPUT", "BUTTON"].indexOf(e.target.tagName)
  ) {
    return;
  }

  body.classList.remove("search-active");
  body.removeEventListener("click", window.closeSearch);
  body.removeEventListener("keydown", window.closeSearch);
};

window.toggleSearch = function (e) {
  var bodyClasses = document.body.classList;

  if (bodyClasses.contains("search-active")) {
    window.closeSearch(e, true);
  } else {
    bodyClasses.remove("menu-active");
    bodyClasses.add("search-active");
    document.getElementById("header-search-field").focus();
    document.body.addEventListener("click", window.closeSearch);
    document.body.addEventListener("keydown", window.closeSearch);
    e.stopPropagation();
  }
};

var search_btn = document.getElementById("search-btn");

if (search_btn) {
  document
    .getElementById("search-btn")
    .addEventListener("click", window.toggleSearch);
}

/*
 * Setup functions, variables, object
 */
ckdc.require([], function ($) {
  var setupOnceFunctions = {};
  var setupContentFunctions = {};
  var setupDone = false;

  // Run initial setup. Everything else is called from this.
  setupOnce();

  // Setup on pageload
  function setupOnce() {
    setupDone = true;

    // any registered setup once functions?
    $.each(setupOnceFunctions, function (i, fn) {
      if (typeof fn === "function") {
        fn();
      }
    });

    // initial setup of all content
    _setupContent(ckdc.html);
  }

  // Setup when new content is added
  function _setupContent(newContent) {
    if (typeof newContent == "undefined") {
      newContent = ckdc.html;
    }

    setupEvents(newContent);

    // misc classes
    if (isNewVisit()) {
      ckdc.body.addClass("new-visit");
    }

    // any registered setup content functions?
    $.each(setupContentFunctions, function (i, fn) {
      if (typeof fn === "function") {
        fn(newContent);
      }
    });
  }

  // Setup various events when new content is added
  function setupEvents(newContent) {
    // jssubmit class: form submit from any element
    $(".jssubmit", newContent)
      .off("click.ckdc")
      .on("click.ckdc", function (e) {
        $(e.target).closest("form").submit();
        e.preventDefault();
        return false;
      });

    // js-link class: allows links from any element (to allow nested links)
    $(".js-link", newContent)
      .off("click.ckdc")
      .on("click.ckdc", function (e) {
        var href = $(this).data("href");

        if (href.length > 0) {
          document.location.href = href;
        }

        e.preventDefault();
        return false;
      });

    // social popup link
    $("body").on("click", "a.social-popup", function (e) {
      window.open(
        e.currentTarget.getAttribute("href"),
        "sharer",
        "toolbar=0,status=0,width=626,height=436"
      );
      return false;
    });
  }

  // Is this a new visit? We want to show custom content to new visitors on first pageload.
  function isNewVisit() {
    // get hostname from an url
    function getHostname(url) {
      var a = document.createElement("a");
      a.href = url;
      return a.hostname;
    }

    // no referer? new visit
    var referrer = document.referrer;

    if (!referrer || !referrer.length) {
      return true;
    }

    var referrerHostname = getHostname(referrer);

    if (!referrerHostname.length) {
      // hostname can be empty for relative links, for example
      return false;
    }

    var currentHostname = getHostname(window.location.href);

    if (!currentHostname.length) {
      // ?
      return false;
    }

    return currentHostname == referrerHostname;
  }

  /**
   * Setup public object
   */
  ckdc.setup = {
    addSetupOnce: function addSetupOnce(key, fn) {
      setupOnceFunctions[key] = fn;

      if (setupDone) {
        fn(ckdc.html);
      }
    },
    removeSetupOnce: function removeSetupOnce(key) {
      if (typeof setupOnceFunctions.key !== "undefined") {
        delete setupOnceFunctions[key];
      }
    },
    addSetupContent: function addSetupContent(key, fn) {
      setupContentFunctions[key] = fn;

      if (setupDone) {
        fn(ckdc.html);
      }
    },
    removeSetupContent: function removeSetupContent(key) {
      if (typeof setupContentFunctions.key !== "undefined") {
        delete setupContentFunctions[key];
      }
    },
    setupContent: function setupContent(newContent) {
      _setupContent(newContent);

      ckdc.html.trigger("ckdc-content-loaded");
      return newContent;
    },
  };

  /**
   * Util public object: general helpfunctions
   */
  ckdc.util = {
    // more extensive isEmpty test, to handle empty objects & blank strings
    isEmpty: function isEmpty(v) {
      // quick test for undefined and null (which is otherwise an object)
      if (typeof v === "undefined" || null === v) {
        return true;
      }

      if (_typeof(v) === "object") {
        // jQuery object, and other objects with length property
        if (v.hasOwnProperty("length")) {
          return !v.length;
        }

        // otherwise use jQuery empty object test
        return $.isEmptyObject(v);
      }

      if (typeof v === "string") {
        v = $.trim(v);
        return !v.length;
      }

      return !v;
    },
    // parse JSON helpfunction, that return null instead of throwing an error on invalid strings
    parseJSON: function parseJSON(s) {
      try {
        if (typeof JSON.parse == "function") {
          // all modern browsers
          return JSON.parse(s);
        }

        if (typeof $.parseJSON == "function") {
          // deprecated in 3.0
          return $.parseJSON(s);
        }

        return null;
      } catch (err) {
        return null;
      }
    },
  };

  /**
   * Add hadDataAttr() function to jQuery
   */
  if (!$.isFunction($.fn.hasDataAttr)) {
    $.fn.extend({
      hasDataAttr: function hasDataAttr(dataName) {
        return typeof this.attr("data-" + dataName) !== "undefined";
      },
    });
  }

  /**
   * CSS / Window size functions
   */
  ckdc.css = {
    // get CSS size name: 'full', 'pad', 'hd-mobile', 'tiny'
    getSizeName: function getSizeName() {
      var width = window.innerWidth;

      if (width > ckdc.fullSizeBreakpoint) {
        return "full"; // 770px +
      } else if (width > 600) {
        return "pad"; // pad / tablets, 601 - 769px
      } else if (window.devicePixelRatio > 1) {
        return "hd-mobile"; // mobile with hd resolution
      } else {
        return "tiny"; // small mobile, no hd resolution
      }
    },
  };

  /**
   * Help functions for preview lists and preview carousels
   */
  ckdc.preview = {
    extraImagesHandling: function extraImagesHandling(item) {
      var extraImageContainer = item.find(".extra-images-container");

      if (extraImageContainer.data("ei")) {
        var extraImagesHtml = unescape(extraImageContainer.data("ei"));
        extraImageContainer.data("ei", "").removeAttr("data-ei");
        extraImageContainer.append(extraImagesHtml);
      }

      if (extraImageContainer.length > 0) {
        var extraImages = extraImageContainer.children(".extra-image");

        if (typeof ckdc.preview.extraImagesHandling.counter == "undefined") {
          ckdc.preview.extraImagesHandling.counter = 0;
        }

        ++ckdc.preview.extraImagesHandling.counter;

        if (extraImages.length > 0) {
          var timerSpeed = 100;
          item.addClass("ei-not-ready");
          extraImages.each(function (i, e) {
            var image = $(e);

            if (!image.prop("complete")) {
              image.addClass("not-loaded");
            } else {
              timerSpeed = 2000;
              item.removeClass("ei-not-ready");
            }
          });

          if (!extraImageContainer.data("loaded")) {
            extraImages.slice(1).addClass("rotate");
            extraImageContainer.data("loaded", 1);
          }

          if (typeof lazyloader !== "undefined") {
            lazyloader.update();
          }

          var counter = ckdc.preview.extraImagesHandling.counter;
          setTimeout(function () {
            ckdc.preview.rotateExtraImages(item, counter);
          }, timerSpeed);
        }
      }
    },
    rotateExtraImages: function rotateExtraImages(item, counter) {
      var timerSpeed = 2000;
      var notLoadedExtraImages = item.find(".extra-image.not-loaded");

      if (notLoadedExtraImages.length > 0) {
        notLoadedExtraImages.each(function (i, e) {
          var image = $(e);

          if (image.prop("complete")) {
            image.removeClass("not-loaded");
          }
        });
      }

      var loadedExtraImages = item.find(".extra-image:not(.not-loaded)");

      if (loadedExtraImages.length <= 0) {
        timerSpeed = 100;
      } else {
        var extraImage = loadedExtraImages
          .filter(".extra-image.rotate:not(.hide)")
          .last();

        if (extraImage.length == 0) {
          extraImage = loadedExtraImages.filter(".extra-image.rotate");
          extraImage.removeClass("hide");
        } else {
          extraImage.addClass("hide");
        }

        if (item.hasClass("ei-not-ready")) {
          item.find(".extra-image").removeClass("hide");
          item.removeClass("ei-not-ready");
        }
      }

      if (
        item.hasClass("selected") &&
        counter == ckdc.preview.extraImagesHandling.counter
      ) {
        setTimeout(function () {
          ckdc.preview.rotateExtraImages(item, counter);
        }, timerSpeed);
      }
    },
  };

  /**
   * Ajax private function
   *
   * Get data object to send with ajax call
   *
   * Original data object can be either object with properties, or array of
   * objects with name & value attributes (from jQuery serializeArray() for
   * example).
   *
   * We want to normalize to array of objects, to allow multiple values with
   * same name to be send (for exampel for PHP [] variable handling).
   */
  function getAjaxData(data, action) {
    var ajaxData = [
      {
        name: "action",
        value: action,
      },
    ];

    if (ckdc.util.isEmpty(data)) {
      return ajaxData;
    }

    $.each(data, function (k, v) {
      if (
        _typeof(v) === "object" &&
        v.hasOwnProperty("name") &&
        v.hasOwnProperty("value")
      ) {
        ajaxData.push(v);
      } else {
        ajaxData.push({
          name: k,
          value: v,
        });
      }
    });
    return ajaxData;
  }

  /**
   * Ajax public helpfunctions
   */
  ckdc.ajax = {
    url: ckdc.ajaxurl,
    blockingElement: null,
    // status enum for ajax call
    statusEnum: {
      pending: "pending",
      done: "done",
      fail: "fail",
    },

    /*
     * Standard AJAX call
     */
    call: function call(action, data, done) {
      if (typeof action !== "string" || !action.length) {
        return null;
      }

      if (_typeof(data) !== "object") {
        data = {};
      }

      // instance of call
      var c = {
        /*
         * Status of call
         *
         * isSuccess : null until call is done, then true / false based on if both call and request was successful (response status > 0)
         *
         * callStatus : enum based on call progress, pending followed by done / fail based on server response
         * serverStatus : status number returned by server (200, 404, 500, ...)
         */
        isSuccess: null,
        callStatus: ckdc.ajax.statusEnum.pending,
        serverStatus: 0,

        /*
         * Response properties, once completed and if available
         */
        response: {
          status: null,
          data: null,
          message: null,
        },
        hasData: null,
        hasMessage: null,

        /*
         * Call properties (for debug purposes)
         */
        ajaxAction: action,
        ajaxData: data,
        responseText: null, // full response text
        // XMLHTTPRequest request
        jqXHR: null, // jqXHR object, can be used as Promise
      };
      var ajaxData = getAjaxData(data, action);

      // use .always() completion instead of success callback do catch all results
      c.jqXHR = $.post(ckdc.ajax.url, ajaxData).always(function () {
        c.serverStatus = c.jqXHR.status;
        c.callStatus =
          200 == c.serverStatus
            ? ckdc.ajax.statusEnum.done
            : ckdc.ajax.statusEnum.fail;
        c.responseText = c.jqXHR.responseText;
        r = ckdc.util.parseJSON(c.responseText);
        var valid = ckdc.ajax.resultValid(r);

        if (valid) {
          c.isSuccess = r.status >= 0;
          c.response.status = r.status;

          if (r.hasOwnProperty("data")) {
            if (!ckdc.util.isEmpty(r.data)) {
              c.hasData = true;
            }

            c.response.data = r.data;
          }

          if (r.hasOwnProperty("msg")) {
            if (!ckdc.util.isEmpty(r.msg)) {
              c.hasMessage = true;
            }

            c.response.message = r.msg;
          }
        } else {
          c.isSuccess = false;
          c.hasData = false;
          c.hasMessage = false;
          c.response.status = -1;
        }

        if (typeof done === "function") {
          done(c.response.data, c);
        }
      });
      return c;
    },

    /*
     * Other AJAX helpfunctions
     */
    resultValid: function resultValid(result) {
      return (
        _typeof(result) == "object" &&
        !ckdc.util.isEmpty(result) &&
        result.hasOwnProperty("status")
      );
    },

    /*
     * AJAX serialization helpfunctions
     */
    startAjaxElement: function startAjaxElement($element, isBlocking) {
      // blocking ajax running?
      if (ckdc.ajax.blockingElement != null) {
        return false;
      }

      if ($element.hasClass("disabled")) {
        return false;
      }

      if ($element.hasClass("ajax-working")) {
        // already working, unable to start, do not proceed
        return false;
      }

      isBlocking = typeof isBlocking !== "undefined" && !!isBlocking;

      if (isBlocking) {
        ckdc.ajax.blockingElement = $element;
        ckdc.body.addClass("ajax-blocking");
      }

      $element.addClass("ajax-working");
      return true;
    },
    endAjaxElement: function endAjaxElement($element) {
      if (
        ckdc.ajax.blockingElement != null &&
        $element.is(ckdc.ajax.blockingElement)
      ) {
        ckdc.ajax.blockingElement = null;
        ckdc.body.removeClass("ajax-blocking");
      }

      $element.removeClass("ajax-working");
    },
    startAjaxButton: function startAjaxButton($button, isBlocking) {
      if (!ckdc.ajax.startAjaxElement($button, isBlocking)) {
        return false;
      }

      $button
        .addClass("busy")
        .append(
          '<span class="ajax-working-spinner"><i class="fa fa-spinner fa-pulse" aria-hidden="true"></i></span>'
        );
      return true;
    },
    endAjaxButton: function endAjaxButton($button) {
      $button.removeClass("busy").find(".ajax-working-spinner").remove();
      ckdc.ajax.endAjaxElement($button);
    },
    startAjaxEvent: function startAjaxEvent(event) {
      event.preventDefault();
      return ckdc.ajax.startAjaxElement($(event.target));
    },
    endtAjaxEvent: function endtAjaxEvent(event) {
      ckdc.ajax.endAjaxElement($(event.target));
    },
  };

  /**
   * Image orientation handling, for images with both vertical & horizontal versions
   */
  ckdc.image = {
    // set image orientation: update src / srcset
    setOrientation: function setOrientation(img, orientation) {
      var o = "img-" + orientation;

      if (img.hasClass(o)) {
        return;
      }

      img.removeClass("img-vertical img-horizontal").addClass(o);
      img.attr("src", img.data(o + "-src"));
      img.attr("srcset", img.data(o + "-srcset"));
    },
    // force orientation for image
    forceOrientation: function forceOrientation(img, orientation) {
      var o = "force-img-" + orientation;

      if (img.hasClass(o)) {
        return;
      }

      img
        .removeClass("force-img-vertical force-img-horizontal")
        .addClass("force-orientation " + o);
      ckdc.image.setOrientation(img, orientation);
    },
    // clear forced orientation for image
    clearForceOrientation: function clearForceOrientation(img) {
      img.removeClass(
        "force-img-vertical force-img-horizontal force-orientation"
      );
      ckdc.image.updateOrientation(img);
    },
    // update image orientation, optionally with page orientation argument
    updateOrientation: function updateOrientation(img) {
      if (img.hasClass("force-orientation")) {
        return;
      }

      ckdc.image.setOrientation(img, ckdc.orientation);
    },
    // update orientation for all dual images (optionally in specified content)
    updateAllOrientation: function updateAllOrientation(content) {
      ckdc.orientation = ckdc.getWindowOrientation();
      var o = "img-" + ckdc.orientation;

      // if no specific content test body class if update already done
      if (typeof content === "undefined" || ckdc.body.is(content)) {
        if (ckdc.body.hasClass(o)) {
          return;
        }

        ckdc.body.removeClass("img-vertical img-horizontal").addClass(o);
        content = ckdc.body;
      }

      var dualImages = $(".img-dual-src", content);

      if (!dualImages.length) {
        return;
      }

      dualImages.each(function () {
        ckdc.image.updateOrientation($(this));
      });
    },
    // force all images (optionally in content) to use orientation
    forceAllOrientation: function forceAllOrientation(orientation, content) {
      var dualImages = $(".img-dual-src", content);

      if (!dualImages.length) {
        return;
      }

      dualImages.each(function () {
        ckdc.image.forceOrientation($(this), orientation);
      });
    },
    // setup image orientation for new content
    setupContent: function setupContent(newContent) {
      ckdc.image.updateAllOrientation(newContent);
    },
  };
  ckdc.setup.addSetupContent("img-dual", ckdc.image.setupContent);

  /**
   * Open and close membership section items
   */
  if ($(".membership-content li").length > 0) {
    $(".membership-content li").on("click", function () {
      $(this).toggleClass("open");
    });
  }

  /**
   * Form handling
   */
  ckdc.form = {
    // clear all form validations
    clearFormValidation: function clearFormValidation(form) {
      form = $(form);
      form.find(".error").removeClass("error");
      form.find(".error-msg").removeClass("error-msg").html("");
      form.find(".success").removeClass("success");
    },
    // Add error markings to a form row
    addInputError: function addInputError(elem, msg) {
      elem = $(elem).parents(".form-row");
      elem.addClass("error");
      var elem_msg = elem.find(".error-msg");

      if (!elem_msg.length) {
        elem_msg = $('<div class="error-msg"></div>');
        elem.append(elem_msg);
      }

      elem_msg.html(msg);
    },
    // Add markup to DD checkbox container (label or something containing type=checkbox)
    ddCheckbox: function ddCheckbox(element_selector) {
      var element_object = $(element_selector);

      if (element_object.length > 0) {
        element_object
          .addClass("dd-checkbox")
          .append('<div class="dd-checkbox-indicator"></div>');
      }
    },
  };

  /**
   * WooCommerce checkboxes
   */
  ckdc.form.ddCheckbox(
    ".woocommerce-form__label-for-checkbox:not(.dd-checkbox), .login label[for=rememberme]:not(.dd-checkbox)"
  );
  $(document.body).on("updated_checkout", function () {
    ckdc.form.ddCheckbox(
      ".woocommerce-form__label-for-checkbox:not(.dd-checkbox)"
    );
  });

  /**
   * Navbar / Header
   */
  ckdc.header = (function () {
    var docElem = document.documentElement,
      header = jQuery("#header"),
      headerHeight = -1,
      doingAnimation = false,
      changeHeaderOn = 50,
      hideHeaderOn = 350,
      scrollDown = false,
      lastPosition = -1,
      postmenuScrolling = false,
      overflowing = "none",
      postmenuContent = document.querySelector("#postmenu ul"),
      contentScrollLeft = 0,
      contentWidth = 0,
      contentWrapper = 0,
      sy = 0,
      mq = window.matchMedia("(min-width: 768px)"),
      activeTimeout = null;

    var scroll =
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      window.oRequestAnimationFrame || // IE Fallback, you can even fallback to onscroll
      function (callback) {
        window.setTimeout(callback, 1000 / 60);
      };

    function scrollPage() {
      sy = window.pageYOffset || docElem.scrollTop;

      // Avoid calculations if not needed (same position or menu already open)
      if (
        lastPosition == sy ||
        document.body.classList.contains("menu-active")
      ) {
        scroll(scrollPage);
        return false;
      } else {
        if (sy >= changeHeaderOn) {
          header.addClass("header-page");
        } else {
          header.removeClass("header-page");
        }

        // Only recalculate position if not animating header right now
        if (!doingAnimation) {
          var diff = lastPosition - sy;

          if (diff < -20) {
            if (scrollDown == false) {
              headerHeight = header.height();
              hideHeaderOn = Math.max(350, sy - headerHeight);
            }

            scrollDown = true;
          } else {
            if (scrollDown == true) {
              headerHeight = header.height();
              hideHeaderOn = Math.max(350, sy - headerHeight);
            }

            scrollDown = false;
          }
        }

        if (sy > hideHeaderOn + headerHeight) {
          header.css("top", "-180px");
          doingAnimation = false;
        } else {
          if (sy > hideHeaderOn) {
            header.css("top", -Math.round(sy - hideHeaderOn) + "px");
            doingAnimation = true;
            $(".user-item.sub-menu-active").removeClass("sub-menu-active");
          } else {
            if ($("body").hasClass("admin-bar")) {
              header.css("top", $("html").css("marginTop"));
            } else {
              header.css("top", "0");
            }

            doingAnimation = false;
          }
        }

        lastPosition = sy;
        scroll(scrollPage);
      }
    }

    function postmenuScroll() {
      contentScrollLeft = postmenuContent.scrollLeft;
      contentWidth = postmenuContent.scrollWidth;
      contentWrapper = postmenuContent.offsetWidth;

      if (
        contentWidth > contentWrapper &&
        contentScrollLeft != 0 &&
        contentWrapper != contentWidth - contentScrollLeft
      ) {
        overflowing = "both";
        document.querySelector("#postmenu-nav button.left").disabled = false;
        document.querySelector("#postmenu-nav button.right").disabled = false;
      } else if (
        contentWrapper == contentWidth - contentScrollLeft &&
        contentWidth > contentWrapper
      ) {
        overflowing = "left";
        document.querySelector("#postmenu-nav button.left").disabled = false;
        document.querySelector("#postmenu-nav button.right").disabled =
          "disabled";
      } else if (contentScrollLeft == 0 && contentWidth > contentWrapper) {
        overflowing = "right";
        document.querySelector("#postmenu-nav button.right").disabled = false;
        document.querySelector("#postmenu-nav button.left").disabled =
          "disabled";
      } else {
        overflowing = "none";
        document.querySelector("#postmenu-nav button.left").disabled =
          "disabled";
        document.querySelector("#postmenu-nav button.right").disabled =
          "disabled";
      }

      document
        .getElementById("postmenu")
        .setAttribute("data-overflowing", overflowing);
      scroll(postmenuScroll);
    }

    // Init events and handlers related to the menu in the header
    function menuEvents() {
      $(".sub-menu-btn, #header-login-btn").click(function (e) {
        $(this).parent().toggleClass("sub-menu-active");
        e.preventDefault();
        $("#header-login.display-help").removeClass("display-help");
        return false;
      });
      $("#main-nav > li:not(.user-item-login) > a").on(
        "mouseenter",
        function () {
          var item = this,
            header = null,
            timeoutValue = 400;

          if (activeTimeout != null) {
            clearTimeout(activeTimeout);
            activeTimeout = null;
          }

          if (mq.matches) {
            header = $("#header");

            if (header.hasClass("show-sub-menu")) {
              timeoutValue = 0;
            }

            activeTimeout = setTimeout(function () {
              activeTimeout = null;
              header
                .addClass("show-sub-menu")
                .find(".sub-menu-active")
                .removeClass("sub-menu-active");
              $(item).parent().addClass("sub-menu-active");
            }, timeoutValue);
          }
        }
      );
      $("#main-nav li.no-click > a").removeAttr("href");
      $("#header").on("mouseleave", function () {
        if (activeTimeout != null) {
          clearTimeout(activeTimeout);
          activeTimeout = null;
        }

        if (mq.matches) {
          $("#header")
            .removeClass("show-sub-menu")
            .find(".sub-menu-active:not(.user-item-login)")
            .removeClass("sub-menu-active");
        }
      });

      // Load login help
      $("#header-login form.login .lost-password a").click(function (e) {
        $("#header-login").addClass("working");
        $("#header-login .help-content").load(
          $(e.target).attr("href") + " #content .entry",
          function () {
            $("#header-login").removeClass("working").addClass("display-help");
            $("#header-login .help-content").prepend(
              '<span class="help-close"></span>'
            );
          }
        );
        e.preventDefault();
        return false;
      });

      // Close login help and restore login form
      $("#header-login").on("click", ".help-close", function (e) {
        $("#header-login").removeClass("display-help");
      });

      // Perform AJAX login on form submit
      $("#header-login form.login").on("submit", function (e) {
        e.preventDefault();
        ckdc.form.clearFormValidation("#header-login form.login");
        var login_pre_error = false;
        var login_form = $("#header-login form.login");
        var login_email = login_form.find('[name="ckdc_email"]').val();

        if (ckdc.util.isEmpty(login_email)) {
          ckdc.form.addInputError(
            '#header-login form.login [name="ckdc_email"]',
            ckdc.s.login_empty_email
          );
          login_pre_error = true;
        }

        var login_password = login_form.find('[name="ckdc_password"]').val();

        if (ckdc.util.isEmpty(login_password)) {
          ckdc.form.addInputError(
            '#header-login form.login [name="ckdc_password"]',
            ckdc.s.login_empty_password
          );
          login_pre_error = true;
        }

        // If pre error, don't post ajax
        if (login_pre_error) {
          return false;
        }

        jQuery.post({
          dataType: "json",
          url: ckdc.ajaxurl,
          data: {
            action: "ckdclogin",
            ckdc_email: login_email,
            ckdc_password: login_password,
            ckdc_remember: login_form
              .find('[name="ckdc_rememberme"]')
              .is(":checked"),
            ckdc_security: login_form.find('[name="member_login_nonce"]').val(),
          },
          beforeSend: function beforeSend() {
            $("#header-login").addClass("working");
          },
          success: function success(data) {
            var login_message = login_form.find(".form-message");
            var is_logged_in =
              _typeof(data) === "object" &&
              data.hasOwnProperty("loggedin") &&
              true == data.loggedin;

            if (is_logged_in) {
              login_message.addClass("success");
            } else {
              login_message.addClass("error");
            }

            if (
              _typeof(data) === "object" &&
              data.hasOwnProperty("message") &&
              data.message.length > 0
            ) {
              login_message.html(data.message);
            }

            if (is_logged_in) {
              if (!ckdc.util.isEmpty(data.redirect_to)) {
                ckdc.simplebox.open(data.redirect_to, {
                  callbackClose: function callbackClose() {
                    document.location.reload(true);
                  },
                });
              } else {
                document.location.reload(true);
              }
            }
          },
          complete: function complete() {
            $("#header-login").removeClass("working");
          },
        });
        return false;
      });
    }

    function initPostmenu() {
      // No postmenu or touch device
      if (
        postmenuContent == null ||
        document.documentElement.classList.contains("touch")
      ) {
        return;
      }

      // Nav buttons actions
      document
        .querySelector("#postmenu-nav button.right")
        .addEventListener("click", function () {
          if (postmenuScrolling === true) {
            return;
          }

          postmenuScrolling = true;
          $(postmenuContent).animate(
            {
              scrollLeft: postmenuContent.scrollLeft + 200,
            },
            500,
            function () {
              postmenuScrolling = false;
            }
          );
        });
      document
        .querySelector("#postmenu-nav button.left")
        .addEventListener("click", function () {
          if (postmenuScrolling === true) {
            return;
          }

          postmenuScrolling = true;
          $(postmenuContent).animate(
            {
              scrollLeft: postmenuContent.scrollLeft - 200,
            },
            500,
            function () {
              postmenuScrolling = false;
            }
          );
        });
      postmenuScroll();
    }

    initPostmenu();
    scrollPage();
    menuEvents();
  })();

  /**
   * JS Popup
   *
   * The main purpose of this code is to have rich html popups that are only
   * inserted into the DOM on hover, so that they are not displayed by Google
   * or FB in the middle of content.
   */
  ckdc.jspopup = {
    setup: function setup(newContent) {
      $(".ckdc-js-popup", newContent)
        .off("mouseenter.jspopup touchstart.jspopup")
        .on(
          "mouseenter.jspopup touchstart.jspopup",
          ckdc.jspopup.popupActivateEvent
        );
    },
    // Event to activate a single popup
    popupActivateEvent: function popupActivateEvent(event) {
      var popup = $(event.target).closest(".ckdc-js-popup");
      /*
       * For some links we want to have hover content but with touch
       * devices just go right to the content.
       */

      if ("touchstart" === event.type && popup.hasClass("no-mobile-popup")) {
        return true;
      }

      ckdc.jspopup.activate(popup, event);
    },
    // Activate a popup: add it to the dom and clean up data and events
    activate: function activate(popup, event) {
      if (!popup.hasClass("ckdc-js-popup")) {
        return;
      }
      // remove js popup class and event handler
      popup
        .removeClass("ckdc-js-popup")
        .off("mouseenter.jspopup touchstart.jspopup");

      if (!popup.hasDataAttr("js-popup")) {
        return;
      }
      // add to the dom
      var content = popup
        .data("js-popup")
        .replace(/\\\'/g, "'")
        .replace(/\\\"/g, '"');

      // unescape popup content
      popup.addClass("ckdc-popup-anchor").append(content);

      // remove data attribute
      popup.removeAttr("data-js-popup");

      // if touchstart, activate touchpopup
      if ("touchstart" === event.type) {
        ckdc.touchpopup.activatePopup(popup);
      }

      ckdc.setup.setupContent(popup);
    },
  };
  ckdc.setup.addSetupContent("js-popup", ckdc.jspopup.setup);

  /**
   * Better popup handling on touch devices
   *
   * For touch events we want one touch to show popup, and any touch
   * outside of popup to close it again. We also want links etc inside
   * the popup to work, once it is open.
   */
  ckdc.touchpopup = {
    setupOnce: function setupOnce() {
      $(document).on(
        "touchstart.touchpopup",
        ".ckdc-popup-anchor",
        ckdc.touchpopup.touchAnchorEvent
      );
      ckdc.body.on("touchstart.touchpopup", ckdc.touchpopup.touchBodyEvent);
    },
    // touch event on .ckdc-popup-anchor
    touchAnchorEvent: function touchAnchorEvent(event) {
      var anchor = $(event.currentTarget);

      // already active? let event go through
      if (anchor.hasClass("active")) {
        return true;
      }

      ckdc.touchpopup.activatePopup(anchor);
      event.preventDefault();
      return false;
    },
    // touch event everywhere, to close popup when needed
    touchBodyEvent: function touchBodyEvent(event) {
      // only when popup is active
      if (!ckdc.body.hasClass("popup-active")) {
        return true;
      }
      // don't handle clicks inside anchor
      if ($(event.target).closest(".ckdc-popup-anchor").length > 0) {
        return true;
      }
      // click outside, deaktivate popups
      ckdc.body.removeClass("popup-active");
      $(".ckdc-popup-anchor.active").removeClass("active");
    },
    // activate popup
    activatePopup: function activatePopup(anchor) {
      anchor.addClass("active");
      ckdc.body.addClass("popup-active");
    },
  };
  ckdc.setup.addSetupOnce("touch-popup", ckdc.touchpopup.setupOnce);

  /**
   * Handle lazy loading of images with vanilla-lazyloading lib
   */
  ckdc.lazyload = {
    doLazyLoading: function doLazyLoading() {
      if (typeof lazyloader === "undefined") {
        lazyloader = new LazyLoad({
          elements_selector: ".lazy",
          threshold: 300, // A number of pixels representing the outer distance off the scrolling area from which to start loading the elements.
          use_native: false, // Set to true in the year of 2037 when native lazy loading is available in browsers.
          callback_loaded: function callback_loaded(el) {
            if (typeof performance.now === "undefined") {
              return;
            }

            if (performance.now() <= 3000) {
              return;
            }

            if (el.closest(".carousel")) {
              // Fade in animation looks weird for carousel on some browsers, so don't do it.
              return;
            }

            el.classList.add("lazy-fade-in");
          },
        });
      } else {
        lazyloader.update();
      }
    },
  };
  ckdc.setup.addSetupOnce("init-lazyloader", ckdc.lazyload.doLazyLoading);
  ckdc.setup.addSetupContent("lazyload", ckdc.lazyload.doLazyLoading);

  /**
   * Add scroll animation to named anchor tag links
   */
  $(document).on("click", 'a[href*="#"]', function (event) {
    if (!$(this).is("a")) {
      return true;
    }

    if (
      window.location.host != this.host ||
      window.location.pathname != this.pathname
    ) {
      return true;
    }

    var hash = this.hash.substr(1);
    var target = $('[name="' + hash + '"]');

    if (!target.length) {
      return true;
    }

    event.preventDefault();
    $("html, body").animate(
      {
        scrollTop: target.offset().top,
      },
      500,
      function () {
        window.location.hash = hash;
      }
    );
    return false;
  });

  /**
   * URL related helpfunctions
   */
  ckdc.url = {
    /**
     * Set endpoint value in an URL string.
     *
     * For example in "/recipes/meatballs/servings/8" the servings endpoint
     * value could be updated.
     *
     * @param string href     URL string to update.
     * @param string endpoint Endpoint string to set value for.
     * @param string value    Value to set endpoint to.
     */
    setURLEndpointValue: function setURLEndpointValue(href, endpoint, value) {
      // match endpoint with argument
      var r = new RegExp("/" + endpoint + "/([^/?#]*)");

      // already set?
      var m = href.match(r);

      if (m && typeof m[0] != "undefined") {
        return href.replace(m[0], "/" + endpoint + "/" + value);
      }

      // not set, add it (before querysting & hashtag)

      // split href into url + querystring + hashtag (if either exists)
      var hrefparts = href.match(/([^?#]*)(\?[^#]*)?(#.*)?/);

      if (!hrefparts || typeof hrefparts[1] == "undefined") {
        return href; // "something weird" happened
      }

      var newhref = hrefparts[1];

      if (newhref.slice(-1) != "/") {
        newhref = newhref + "/";
      }

      newhref = newhref + endpoint + "/" + value;

      if (typeof hrefparts[2] != "undefined") {
        newhref = newhref + hrefparts[2];
      }

      if (typeof hrefparts[3] != "undefined") {
        newhref = newhref + hrefparts[3];
      }

      return newhref;
    },

    /**
     * Set endpoint value in window.location.
     *
     * Uses window.history.replaceState() to avoid reloading page.
     *
     * @param string endpoint Endpoint string to set value for.
     * @param string value    Value to set endpoint to.
     */
    setLocationEndpointValue: function setLocationEndpointValue(
      endpoint,
      value
    ) {
      // only if we can actually replace history
      if (typeof window.history.replaceState !== "function") {
        return;
      }

      window.history.replaceState(
        {},
        document.title,
        ckdc.url.setURLEndpointValue(window.location.href, endpoint, value)
      );
    },
  };

  /**
   * Premium content helpfunctions.
   *
   * There are also premium content functionality in cta-premium-lock.js.
   */
  ckdc.premium = {
    /**
     * Get current premium content used.
     *
     * @return array Array of content ID strings.
     */
    getContentUsed: function getContentUsed() {
      c = Cookies.get( 'ckdc-premium' );
      if ( typeof c == 'undefined' || ! c.hasOwnProperty( 'length' ) ) {
        return [];
      }
      return c.split(',');
    },

    /**
     * Get current premium content used.
     *
     * @param array Array of content ID strings used.
     */
    setContentUsed: function setContentUsed( c ) {
      Cookies.set( 'ckdc-premium', c.join(','), {
        expires: 30,
      } );
    }
  };

  /* Test if current visitor is allowed to view premium content */
  if ( typeof ckdc.user === 'undefined' || typeof ckdc.user.membershipSubscription === 'undefined' || 'ACTIVE' !== ckdc.user.membershipSubscription ) {
    var c = ckdc.premium.getContentUsed();
    if ( c.length >= 3 ) {
      ckdc.body.addClass( 'is-premium-locked' );
    }
  }

  /*
   * Mark JS core setup done
   */
  ckdc.done = true;
});

/*
 * Old script
 *
 * Todo: clean up and migrated to new objects
 */

// Check if user mobile or not
ckdc.isMobile = false; //initiate as false
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
|| /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) ckdc.isMobile = true;

ckdc.ready(function () {
  jQuery("#comments")
    .find(".pop-commentlist .comment-wrapper")
    .each(function () {
      var w = jQuery(this);

      if (w.height() > 300) {
        w.css("height", "300px");
      }

      if (w.children(".comment-wrapper-inner").height() <= w.height()) return;
      var e = w.siblings(".comment-expand");
      e.css("display", "block")
        .show()
        .click(function (event) {
          event.preventDefault();
          var e = jQuery(this);
          var w = e.siblings(".comment-wrapper");
          w.stop().animate(
            {
              "max-height": w.children(".comment-wrapper-inner").height(),
            },
            250,
            function () {
              e.remove();
            }
          );
          return false;
        });
    });

  // remove quote button hide class, and handle click
  jQuery("#comment-reply-quote")
    .removeClass("hide")
    .click(function (event) {
      var id_input = jQuery("#comment-reply-parent");
      if (id_input.length <= 0) return false;
      var id = parseInt(id_input.val(), 10);
      if (!id || id <= 0) return false;
      var content = jQuery("#comment-content-" + id);
      if (!content.length) return false;
      var h = content.html();
      if (h.length <= 0) return false;
      h = "<blockquote>\r" + h + "\r</blockquote>";
      var t = jQuery("#comment");
      var current_text = t.val();
      if (current_text.length > 0) h = current_text + "\r\n" + h;
      t.val(h);
      return false;
    });
  jQuery("a.comment-reply-link").click(function (event) {
    var a = jQuery(this);
    var parts = a.attr("id").split("-");
    var id = parseInt(parts.pop(), 10);
    var comment = jQuery("#comment-" + id);
    if (!comment.length) return true;
    var author = a.attr("author");
    var nr = a.attr("number");
    jQuery("#comment-reply-parent").val(id);
    var status = jQuery("#comment-reply-status-wrapper");

    if (status.length >= 1) {
      jQuery("#comment-reply-nr", status).text(nr);
      jQuery("#comment-reply-author", status).text(author);
    }

    status.removeClass("hide").show();
    comments_show_respond();
    jQuery("#comment").focus();
    event.preventDefault();
    return false;
  });
  window.onresize = function() {
    ckdc.image.updateAllOrientation();
  };

  if (ckdc.window.width() < ckdc.fullSizeBreakpoint) {
    if (typeof infinite_scroll != "undefined") {
      jQuery(infinite_scroll.contentSelector).infinitescroll("pause");
    }
  }
  // is element close enough to load? (within one window height)
  function is_load_element_close(e) {
    var window_height = ckdc.window.height();
    var window_bottom = ckdc.window.scrollTop() + window_height;
    var e_top = e.offset().top;
    return e_top - window_height < window_bottom;
  }

  var newsfeed = jQuery("#newsfeed-link");

  function maybe_load_newsfeed_link() {
    if (typeof newsfeed == "undefined" || newsfeed.length <= 0) {
      return;
    }
    // close enough?
    if (!is_load_element_close(newsfeed)) {
      return;
    }

    var newsfeed_link = newsfeed.attr("href");

    // don't try to load again
    ckdc.window.off("scroll", maybe_load_newsfeed_link);
    newsfeed = undefined;

    if (typeof newsfeed_link == "undefined") {
      return;
    }

    jQuery("#newsfeed-wrapper").remove();

    // get footer start element
    var before = jQuery("#above-footer-sidebar");

    if (!before.length) {
      before = jQuery("#footer-widgets");
    }

    if (!before.length) {
      before = jQuery("#footer");
    }

    if (!before.length) {
      return;
    }

    before.before(
      jQuery(
        '<div class="fix"></div><div id="newsfeed-loader"><i class="fa fa-spinner fa-pulse"></i></div><div class="newsfeed-load-wrapper section-fixed-width" id="newsfeed-load" style="display: none;"></div>'
      )
    );
    var load_div = jQuery("#newsfeed-load");
    load_div.load(newsfeed_link + " #content", function () {
      jQuery("#newsfeed-loader").remove();
      load_div.slideDown();

      if (typeof window.fbAsyncInit == "function") {
        window.fbAsyncInit();
      }

      content_loaded();
    });
  }
  // startup newsfeed load watcher
  if (typeof newsfeed != "undefined" && newsfeed.length >= 1) {
    ckdc.window.on("scroll", maybe_load_newsfeed_link);
    setTimeout(function () {
      maybe_load_newsfeed_link();
    }, 500);
  }

  var newsfeed_post = jQuery("#newsfeed-post-link");

  function maybe_load_newsfeed_post_link() {
    if (typeof newsfeed_post == "undefined" || newsfeed_post.length <= 0) {
      return;
    }

    // close enough?
    if (!is_load_element_close(newsfeed_post)) {
      return;
    }

    var newsfeed_post_link = newsfeed_post.attr("href");

    // don't try to load again
    ckdc.window.off("scroll", maybe_load_newsfeed_post_link);
    newsfeed_post = undefined;

    if (typeof newsfeed_post_link == "undefined") {
      return;
    }

    jQuery("#newsfeed-post-wrapper").remove();

    // get footer start element
    var insert_into = jQuery("#main");

    if (!insert_into.length) {
      return;
    }

    insert_into.append(
      jQuery(
        '<div class="fix"></div><div id="newsfeed-loader"><i class="fa fa-spinner fa-pulse"></i></div><div class="newsfeed-load-wrapper section-fixed-width" id="newsfeed-post-load" style="display: none;"></div>'
      )
    );
    var load_div = jQuery("#newsfeed-post-load");
    load_div.load(
      newsfeed_post_link + " #main .news-archive, #main .nav-entries",
      function () {
        jQuery("#newsfeed-loader").remove();
        load_div.slideDown();
        content_loaded();
      }
    );
  }

  // startup newsfeed post load watcher
  if (typeof newsfeed_post != "undefined" && newsfeed_post.length >= 1) {
    ckdc.window.on("scroll", maybe_load_newsfeed_post_link);
    setTimeout(function () {
      maybe_load_newsfeed_post_link();
    }, 500);
  }

  // Hidden shortcode
  ckdc.body.on(
    "click",
    ".hidden-wrapper a.expand, .hidden-wrapper a.collapse",
    function (e) {
      var a = jQuery(e.target);
      var wrapper = a.parents(".hidden-wrapper");
      var content = wrapper.children(".hidden-content");

      if (a.hasClass("collapse")) {
        content.show();

        if (wrapper.hasClass("animate")) {
          content.slideUp(200);
        } else {
          content.hide();
        }

        a.hide();
        wrapper.find("a.expand").show();
      } else if (a.hasClass("expand")) {
        a.hide();
        wrapper.find("a.collapse").show();

        if (wrapper.hasClass("animate")) {
          content.slideDown(200);
        } else {
          content.show();
        }
      }

      e.preventDefault();
      return false;
    }
  );

  // Hide the "leave a reply" clutter
  var respond = jQuery("#respond");
  var respond_hidden = jQuery(
    ".logged-in-as, .form-submit, .comment-form-line",
    respond
  );
  var respond_comment = jQuery("#comment", respond);

  function comments_show_respond() {
    respond_comment.off("click blur", comments_show_respond);

    if (respond_hidden.is(":visible")) {
      return;
    }

    respond_hidden.slideDown();
    respond_comment
      .animate({
        height: "250px",
      })
      .removeClass("inactive");
  }

  if (respond.length > 0) {
    respond_hidden.hide();
    respond_comment.attr("rows", 3).addClass("inactive");
    respond_comment.on("click blur", comments_show_respond);
  }

  var survey = jQuery("#ckdc-survey-wrapper");

  if (survey.length > 0) {
    setTimeout(function () {
      survey.slideDown();
    }, 1000);
  }

  function stop_event(e) {
    e.preventDefault();
    return false;
  }

  function rating_restore_value(rating) {
    var v = rating.data("rating");

    if (typeof v == "undefined") {
      return;
    }

    v = Math.max(v, 0);
    v = Math.min(v, 5);
    rating.attr("title", v);
    rating.find(".stars-rating").css("width", v + "em");
  }

  function rating_mouseout(e) {
    var rating = jQuery(this);
    rating_restore_value(rating);
  }

  function get_rating_value_on_event(rating, e) {
    if (!rating.hasClass("stars")) {
      return rating.data("rating") > 0 ? "0" : "1"; // flip value if ! stars
    }

    var offset = rating.offset();
    var x = e.pageX - offset.left;
    var width = Math.max(1, rating.width());
    return Math.min(5, Math.max(1, Math.ceil((x * 5) / width)));
  }

  function rating_mousemove(e) {
    var rating = jQuery(this);
    var v = get_rating_value_on_event(rating, e);
    rating.attr("title", v);
    rating.find(".stars-rating").css("width", v + "em");
  }

  function parse_ajax_result(r) {
    return ckdc.util.parseJSON(r);
  }

  function ajax_result_valid(r) {
    return ckdc.ajax.resultValid(r);
  }

  function rating_click(e) {
    var this_rating = jQuery(this);
    var v = get_rating_value_on_event(this_rating, e);
    rating_events_off(this_rating);
    e.preventDefault();

    if (typeof ckdc == "undefined") {
      return false;
    }

    this_rating
      .removeClass("rating-open")
      .addClass("rating-closed rating-pending");
    this_rating.after(
      ' <div class="rating-response-wrapper rating-response-' +
        jQuery.now() +
        '"><i class="fa fa-spinner fa-pulse rating-working"></i></div>'
    );
    jQuery.post(
      ckdc.ajaxurl,
      {
        action: "ckdc_rate",
        id: this_rating.data("id"),
        key: this_rating.data("key"),
        nonce: this_rating.data("nonce"),
        args: this_rating.attr("data-args") ? this_rating.data("args") : "",
        v: v,
      },
      function (response) {
        var r = parse_ajax_result(response);

        if (!ajax_result_valid(r)) {
          this_rating.after(
            ' <div class="rating-response-wrapper"><div class="rating-response">Could not connect to server!</div></div>'
          );
          return;
        }

        if (r.hasOwnProperty("data") && r.data) {
          this_rating.parents(".rating-wrapper").replaceWith(r.data);
          content_loaded();
          return;
        }

        if (r.hasOwnProperty("msg") && r.msg) {
          this_rating.after(
            ' <div class="rating-response-wrapper"><div class="rating-response">' +
              r.msg +
              "</div></div>"
          );
          return;
        }

        this_rating.after(
          ' <div class="rating-response-wrapper"><div class="rating-response">Bad response from server!</div></div>'
        );
        return;
      }
    );
    return false;
  }

  function is_touch_enabled() {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }

  function rating_events_on(rating) {
    if (is_touch_enabled()) {
      return;
    }

    rating.addClass("js-on");

    if (rating.hasClass("stars")) {
      rating.on("mouseleave", rating_mouseout);
      rating.on("mousemove", rating_mousemove);
    }

    rating.on("click", rating_click);
  }

  function rating_events_off(rating) {
    if (is_touch_enabled()) {
      return;
    }

    if (rating.hasClass("stars")) {
      rating.off("mouseleave", rating_mouseout);
      rating.off("mousemove", rating_mousemove);
    }

    rating.off("click", rating_click);
    rating.on("click", stop_event);
  }

  rating_events_on(jQuery(".rating-open:not(.js-on)"));
  jQuery(".rating-closed").on("click", stop_event);
  jQuery(".preview-item, .preview-item a").on("focus touchstart", function (e) {
    var t = jQuery(this);

    if (!t.hasClass(".preview-item")) {
      t = t.closest(".preview-item");

      if (!t.length) {
        return;
      }
    }

    t.toggleClass("active");
  });

  /*
   * Language switcher in footer
   */
  jQuery(".footer-language .current-language").on("click", function (e) {
    jQuery(".footer-language").toggleClass("show-languages");

    if (jQuery(".footer-language").hasClass("show-languages")) {
      jQuery("body").on("click", ckdc_hide_languages);
    } else {
      jQuery("body").off("click", ckdc_hide_languages);
    }

    e.preventDefault();
    return false;
  });

  // Switch language link, save cookie with prefered language
  jQuery("body").on("click", ".change-prefered-language", function (e) {
    var l = e.currentTarget.getAttribute("data-language");
    Cookies.set("ckdc-prefered-language", l, {
      expires: 365,
    });
    return true;
  });

  function ckdc_hide_languages(e) {
    jQuery(".footer-language").removeClass("show-languages");
    jQuery("body").off("click", ckdc_hide_languages);
  }

  /*
   * Popup
   */
  jQuery(".ckdc-popup-click").on("click", function (e) {
    jQuery(this).toggleClass("active");
    e.preventDefault();
    return false;
  });

  /*
   * Recipe steps
   */
  jQuery(".recipe-steps-item").on("click", function () {
    jQuery(this).toggleClass("done");
  });

  /*
   * Recipe nutrition show
   */
  jQuery(".more-nutrients-title").on("click", function () {
    // Don't show if feature lock is enabled.
    if ( typeof ckdc.premiumLock !== 'undefined' ) {
      return false;
    }

    ckdc.events.recipe('recipe_view_nutrition');

    jQuery(this).parent().toggleClass("show");
  });
  var ingredients = jQuery(".ckdc-recipe-ingredients");
  var mealplan_settings = jQuery(".ckdc-mealplan-settings");
  var servings_settings = jQuery(".ckdc-servings");
  var unit = Cookies.get("ckdc-unit");
  var ingredient_default_unit = ingredients.data("default-unit");

  if (
    ingredients.length > 0 &&
    typeof unit != "undefined" &&
    typeof ingredient_default_unit != "undefined" &&
    unit != ingredient_default_unit
  ) {
    ingredients
      .removeClass("ingredient-show-" + ingredient_default_unit)
      .addClass("ingredient-show-" + unit);
  }

  var mealplan_default_unit = mealplan_settings.data("default-unit");

  if (
    mealplan_settings.length > 0 &&
    typeof unit != "undefined" &&
    typeof mealplan_default_unit != "undefined" &&
    unit != mealplan_default_unit
  ) {
    mealplan_settings
      .removeClass("ingredient-show-" + mealplan_default_unit)
      .addClass("ingredient-show-" + unit);

    if (
      ingredients.length > 0 &&
      typeof ingredient_default_unit == "undefined"
    ) {
      ingredients
        .removeClass("ingredient-show-" + mealplan_default_unit)
        .addClass("ingredient-show-" + unit);
    }
  }

  jQuery(".ckdc-servings-select-unit").on("click", function () {
    var $this = jQuery(this);
    ingredients
      .removeClass("ingredient-show-" + $this.data("remove-unit"))
      .addClass("ingredient-show-" + $this.data("add-unit"));
    mealplan_settings
      .removeClass("ingredient-show-" + $this.data("remove-unit"))
      .addClass("ingredient-show-" + $this.data("add-unit"));
    Cookies.set("ckdc-unit", $this.data("add-unit"), {
      expires: 365,
    });
  });
  servings_settings.find("select").on("change", function () {
    /* Don't change if feature lock is enabled. */
    if ( typeof ckdc.premiumLock !== "undefined" ) {
      return false;
    }
    var $this = jQuery(this);
    var value = $this.val();

    if (!value) {
      return;
    }

    ingredients.each(function () {
      var this_list = jQuery(this);
      var effective_value = value;
      var display_value = value;

      if (this_list.data("servings-mult") > 1) {
        effective_value = Math.round(value * this_list.data("servings-mult"));
        display_value = "" + value + " + " + value;
      }

      if (effective_value == this_list.data("default-servings")) {
        this_list.parents(".recipe-wrapper").removeClass("portions-scaled");
      } else {
        this_list.parents(".recipe-wrapper").addClass("portions-scaled");
      }

      this_list.find(".ingredient-value").each(function (i, e) {
        var v_item = jQuery(this);

        try {
          var servings_data = v_item.data("servings");
        } catch (err) {
          return;
        }

        if (!(effective_value in servings_data)) {
          return;
        }

        v_item.html(servings_data[effective_value]["value"]);
        v_item
          .parents(".ckdc-ingredient")
          .addClass(servings_data[effective_value]["set"])
          .removeClass(servings_data[effective_value]["remove"]);
      });
      this_list.find(".ckdc-servings .value:not(select)").html(display_value);
    });

    if (value == 1) {
      servings_settings.removeClass("plural").addClass("singular");
    } else {
      servings_settings.removeClass("singular").addClass("plural");
    }

    mealplan_settings.find(".ckdc-servings .value:not(select)").html(value);
    ckdc.url.setLocationEndpointValue(ckdc.s.servings, value);

    // update mealplan menu links, if there are any!
    jQuery(".mealplan-menu a.tab-menu-item").each(function () {
      var a = jQuery(this);
      a.attr(
        "href",
        ckdc.url.setURLEndpointValue(a.attr("href"), ckdc.s.servings, value)
      );
    });
  });

  function content_loaded() {
    rating_events_on(jQuery(".rating-open:not(.js-on)"));
    jQuery(".rating-closed").on("click", stop_event);
    setTimeout(function () {
      jQuery(".fadeaway").fadeOut(1500, function () {
        jQuery(this).remove();
      });
    }, 1000);
    compact_on();
    ajax_load_link_on();
    ckdc.setup.setupContent();
  }

  /* Live search */
  function live_search(live_form) {
    live_form.data("timeout", 0);
    var args_string = live_form.serialize();

    // same as last search?
    if (live_form.data("last-search") == args_string) {
      return;
    }

    live_form.data("busy", 1);
    live_form.data("last-search", args_string);
    live_form
      .find(".btn-fa")
      .removeClass("fa-search")
      .addClass("fa-spinner fa-pulse fa-fw");
    var args = live_form.serializeArray();
    var search_string = live_form.find(".s").val();

    /* ignore short search lengths */
    if (search_string.length < 3) {
      var live_result = live_form.find(".live-search-result");
      live_result.remove();
      live_form.data("busy", 0);
      live_form
        .find(".btn-fa")
        .removeClass("fa-spinner fa-pulse fa-fw")
        .addClass("fa-search");
      live_search_out(live_form.closest(".live-search-form-wrapper"), true);
      return;
    }

    args.push({
      name: "action",
      value: "ckdc_live_search",
    });
    jQuery.post(ckdc.ajaxurl, args, function (str) {
      // check if search form has been changed since request
      var current_args_string = live_form.serialize();

      if (args_string != current_args_string) {
        live_search(live_form);
        return;
      }

      var live_result = live_form.find(".live-search-result");

      if (str == "-1" || str == "0") {
        live_result.slideUp(function () {
          live_result.remove();
        });
      } else {
        if (live_result.length > 0) {
          live_result.replaceWith(str);
        } else {
          live_form.append(str);
        }

        ckdc.setup.setupContent(live_form);
        live_search_in(live_form.closest(".live-search-form-wrapper"));
      }

      live_form
        .find(".btn-fa")
        .removeClass("fa-spinner fa-pulse fa-fw")
        .addClass("fa-search");
      live_form.data("busy", 0);
    });
  }

  function live_search_in(live_wrapper) {
    live_wrapper.data("focus-timeout", 0);

    if (live_wrapper.hasClass("active")) {
      return;
    }

    var live_result = live_wrapper.find(".live-search-result");

    if (!live_result.length) {
      return;
    }

    live_wrapper.addClass("active");
    live_result.show();

    if (jQuery(window).width() > 600) {
      live_wrapper
        .siblings(".live-search-overlay")
        .stop()
        .css({
          backgroundColor: "rgba(255,255,255,0)",
        })
        .addClass("active")
        .animate(
          {
            backgroundColor: "rgba(255,255,255,0.95)",
          },
          "slow"
        );
    }

    var flexslider = jQuery(".flexslider");

    if (flexslider.length && typeof flexslider.flexslider == "function") {
      flexslider.flexslider("stop");
    }
  }

  function live_search_out(live_wrapper, force) {
    if (
      !force &&
      (live_wrapper.is(":hover") || live_wrapper.find("input").is(":focus"))
    ) {
      return;
    }

    live_wrapper.data("focus-timeout", 0);
    live_wrapper.removeClass("active");

    if (jQuery(window).width() > 600) {
      live_wrapper.find(".live-search-result").hide();
    }

    live_wrapper
      .siblings(".live-search-overlay")
      .stop()
      .animate(
        {
          backgroundColor: "rgba(255,255,255,0)",
        },
        "slow",
        function () {
          jQuery(this).removeClass("active");
        }
      );
    var flexslider = jQuery(".flexslider");

    if (flexslider.length && typeof flexslider.flexslider == "function") {
      flexslider.flexslider("play");
    }
  }

  jQuery("form.live-search-form")
    .on("focus mouseenter", function (event) {
      var wrapper = jQuery(this).closest(".live-search-form-wrapper");

      // existing timeout?
      var timeout = wrapper.data("focus-timeout");

      if (timeout > 0) {
        clearTimeout(timeout);
        wrapper.data("focus-timeout", 0);
      }

      live_search_in(wrapper);
    })
    .on("focusout mouseleave", function (event) {
      var wrapper = jQuery(this).closest(".live-search-form-wrapper");

      // existing timeout?
      var timeout = wrapper.data("focus-timeout");

      if (timeout > 0) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(function () {
        live_search_out(wrapper, false);
      }, 200);
      wrapper.data("focus-timeout", timeout);
    })
    .find(".s")
    .on("keyup", function (event) {
      var live_form = jQuery(this).closest(".live-search-form");

      // active search?
      if (live_form.data("busy") > 0) {
        return; // we will re-check search string and redo search if needed
      }

      // existing timeout?
      var timeout = live_form.data("timeout");

      if (timeout > 0) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(function () {
        live_search(live_form);
      }, 200);
      live_form.data("timeout", timeout);
    });
  var advanced_search_form = jQuery("#advanced_search_form");

  function advanced_search() {
    var args_string = advanced_search_form.serialize();
    // same as last search?
    if (advanced_search_form.data("last-search") == args_string) {
      return;
    }

    advanced_search_form.data("busy", 1);
    advanced_search_form.data("last-search", args_string);
    advanced_search_form
      .find(".btn-fa")
      .removeClass("fa-search")
      .addClass("fa-spinner fa-pulse fa-fw");
    var args = advanced_search_form.serializeArray();

    // save to update title & url after search done
    var search_string = advanced_search_form.find(".s").val();
    var search_args = jQuery.grep(args, function (el, i) {
      // remove paged argument from search args used
      return !el.hasOwnProperty("name") || el.name != "sp";
    });
    var search_queryargs = "?" + jQuery.param(search_args);
    args.push({
      name: "action",
      value: "ckdc_search",
    });
    jQuery.post(ckdc.ajaxurl, args, function (str) {
      // check if search form has been changed since request
      var current_args_string = advanced_search_form.serialize();

      if (args_string != current_args_string) {
        advanced_search();
        return;
      }
      // update page title
      if (search_string.length > 0) {
        document.title = ckdc.s.search_title.replace(/%s/, search_string);
      } else {
        document.title = ckdc.s.empty_search_title;
      }
      // update url
      if (typeof window.history.replaceState === "function") {
        var href = window.location.href;
        href =
          href.replace(/page\/[0-9]+\/?/i, "").replace(/\?.*$/i, "") +
          search_queryargs;
        window.history.replaceState({}, document.title, href);
      }

      advanced_search_form
        .find(".btn-fa")
        .removeClass("fa-spinner fa-pulse fa-fw")
        .addClass("fa-search");
      advanced_search_form.data("busy", 0);

      if (str == "-1" || str == "0" || str.length == 0) {
        return;
      }

      jQuery("#search-result").replaceWith(str);
      content_loaded(); // Ensure lazy loading is run for resulting images.
    });
  }

  advanced_search_form
    .find("input, select")
    .on("change keyup", function (event) {
      var $this = jQuery(this);
      // update checkbox selected display
      if ($this.is(":checkbox")) {
        var wrapper = $this.closest(".advanced_search_tax");
        var desc = "";
        wrapper
          .find(":checkbox:checked")
          .siblings("label")
          .each(function (i) {
            if (desc.length) {
              desc = desc + ", ";
            }

            desc = desc + jQuery(this).html();
          });
        wrapper.find(".selected-terms").html(desc);
      }
      // switch search type
      if ($this.is('[name="st"]')) {
        var search_type = $this.val();
        advanced_search_form.removeClass();
        advanced_search_form.addClass("search-" + search_type);
        jQuery("#search-result").html("");
      }
      // active search?
      if (advanced_search_form.data("busy") > 0) {
        return; // we will check and redo search if needed
      }
      // clear existing timeout
      var timeout = advanced_search_form.data("timeout");

      if (timeout > 0) {
        clearTimeout(timeout);
        advanced_search_form.data("timeout", 0);
      }

      if (event.type == "keyup") {
        // search if s empty or at least 3 characters
        var len = advanced_search_form.find(".s").val().length;

        if (len >= 1 && len < 3) {
          return;
        }
        // don't do search directly, set timeout to allow more keypresses
        timeout = setTimeout(function () {
          advanced_search();
        }, 500);
        advanced_search_form.data("timeout", timeout);
      } else {
        advanced_search();
      }
    });

  
  if (typeof BareFoot !== "undefined") {
    lf = new BareFoot();
    lf.init();
  }
  
  jQuery("a.share-fb").on("click", function (e) {
    if (typeof FB == "undefined") {
      return true;
    }

    var posturl = jQuery(this).data("posturl");
    FB.ui(
      {
        method: "share",
        href: posturl,
      },
      function (r) {}
    );
    e.preventDefault();
    return false;
  });
  jQuery("a.user-mark").on("click", function (e) {
    var mark = jQuery(this);

    if (mark.hasClass("busy")) {
      e.preventDefault();
      return false;
    }

    const markType = mark.data("marktype");
    const postType = mark.data("posttype");

    mark.addClass("busy");
    var is_marked = mark.hasClass("user-mark-on");
  
    const ajaxOptions = {
      url: ckdc.ajaxurl,
      type: "POST",
      data: {
        action: "ckdc_mark_post",
        post_id: mark.data("postid"),
        mark: is_marked ? "off" : "on",
        type: markType,
        nonce: mark.data("marknonce"),
      },
      success: function (response) {
        if (response == "on") {
          mark.removeClass("user-mark-off").addClass("user-mark-on");
  
          if ( !ckdc.featureFlags.favoritesApi && markType === 'favorite' ) {
            const postType = mark.data('posttype');
            postType && ckdc.events.favorite( postType, mark.data('postid') );
          }

          if (markType === "watch") {
            ckdc.events.video("video_watch_later", mark.data("postid"));
          }
        } else if (response == "off") {
          mark.removeClass("user-mark-on").addClass("user-mark-off");
        }
  
        // dd-api response for favorites
        if (ckdc.featureFlags.favoritesApi && response && response.data) {
          if (is_marked) {
            mark.removeClass("user-mark-on").addClass("user-mark-off");
          } else {
            mark.removeClass("user-mark-off").addClass("user-mark-on");
            postType && ckdc.events.favorite(postType, mark.data("postid"));
          }
        }
  
        mark.removeClass("busy");
      },
      error: function () {
        mark.removeClass("busy");
      }
    };
  
    if (ckdc.featureFlags.favoritesApi && markType === "favorite" && postType === "kd_recipe") {
      ajaxOptions.url = ckdc.DDAPI + '/v1';

      const favoriteAction = mark.hasClass("user-mark-on") ? false : true;
      const mutation = `mutation Favorites { 
          setFavorite(id: "${mark.data(
            "tokenid"
          )}", kind: RECIPE, favorite: ${favoriteAction})
          }`;
  
      ajaxOptions.data = JSON.stringify({
        query: mutation,
      });
      ajaxOptions.beforeSend = function (xhr) {
        const authCookieAccessToken = Cookies.get("auth");
        xhr.setRequestHeader("Authorization", `Bearer ${authCookieAccessToken}`);
      };
      ajaxOptions.contentType = "application/json; charset=utf-8";
      ajaxOptions.dataType = "json";
    }
  
    jQuery.ajax(ajaxOptions);
    e.preventDefault();
    return false;
  });  

  function compact_click(e) {
    if (jQuery(e.target).closest("a").length) {
      return true;
    }

    var $this = jQuery(this);
    $this.find(".compact-split").remove();
    $this.find(".compact-only").remove();
    $this.find(".compact-part").slideDown("fast", function () {
      $this
        .removeClass("compact")
        .addClass("compact-expanded")
        .removeAttr("title");
    });
  }

  function compact_on() {
    jQuery(".compact:not(.js-on)").addClass("js-on").on("click", compact_click);
  }

  compact_on();

  function ajax_load_link(e) {
    var link = jQuery(this);
    var link_href = link.attr("href");
    var ajax_href = link.attr("data-ajax-href");
    var load_href = !!ajax_href ? ajax_href : link_href;

    if (!load_href) {
      e.preventDefault();
      return false;
    }

    if (link.hasClass("busy")) {
      e.preventDefault();
      return false;
    }

    link.addClass("busy");
    var is_replace = link.hasClass("ajax-load-replace");
    var ajax_wrapper = null;
    var spinner = jQuery(
      '<span class="ajax-load-working"><i class="fa fa-spinner fa-pulse rating-working"></i></span>'
    );

    if (is_replace) {
      ajax_wrapper = link.closest(".ajax-load-wrapper");
      spinner.addClass("ajax-load-replace").prependTo(ajax_wrapper);
    } else {
      spinner.insertAfter(link);
    }

    // update url?
    if (typeof window.history.replaceState === "function") {
      window.history.replaceState({}, document.title, link_href);
    }

    jQuery.get(load_href, function (response) {
      spinner.remove();

      if (is_replace) {
        ajax_wrapper.replaceWith(response);
      } else {
        var r = jQuery('<div class="ajax-load-content">' + response + "</div>");
        link.after(r);
        r.hide().slideDown(200, function () {
          content_loaded();
        });
        link.slideUp(100, function () {
          link.remove();
        });
      }

      content_loaded();
    });
    e.preventDefault();
    return false;
  }

  function ajax_load_link_on() {
    jQuery(".ajax-load")
      .removeClass("ajax-load")
      .addClass("ajax-load-ready")
      .on("click", ajax_load_link);
  }

  ajax_load_link_on();
  jQuery(".scrolldown").on("click", function (e) {
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      e.returnValue = false;
    }

    jQuery("html, body").animate(
      {
        scrollTop: jQuery(jQuery(this).attr("href")).offset().top - 50,
      },
      500
    );
  });
  // setup done
  ckdc.html.addClass("jsready");
});

function ckdc_print_page() {
  ckdc.events.recipe('recipe_printed');

  jQuery("body").addClass("force-horizontal");
  ckdc.image.updateAllOrientation();
  jQuery("#huge-feature-image").removeAttr("style");
  jQuery("#huge-feature-image-inner").removeAttr("style");
  jQuery(".huge-feature-content").removeAttr("style");
  setTimeout(function () {
    window.print();
  }, 200);
  return false;
}
